export default "__VITE_ASSET__Dl5V9mey__"